<template>
    <div :class="['pp',expanded ? 'expanded':'']">
        <div class="contents">            
            <div class="xx" @click="expanded=false">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" 
                    viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                    <path d="M256-227.69 227.69-256l224-224-224-224L256-732.31l224 224 224-224L732.31-704l-224 224 224 224L704-227.69l-224-224-224 224Z"/></svg>
            </div>
            <!-- popup contents -->
            <span>Wir sind für Sie da!</span>
            Tel.: +496251-16-1610 (DE)<br/><br/>
            Fragen Sie Ihren 
            Außendienstmitarbeiter nach einer Test-OP und lassen Sie sich von den 
            Vorteilen der MIS-Implantate überzeugen!
            <div>
                <a href="https://www.dentsplysirona.com/de-de/entdecken/kategorien-entdecken/implantologie/kontakt.html" target="_blank">
                    Kontaktieren Sie uns
                </a>
            </div>
        </div>        
        <div class="bg">
            <div class="verTitle" @click="expanded=!expanded">
                <span>Kontaktieren Sie uns! <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-371.69 267.69-584 296-612.31l184 184 184-184L692.31-584 480-371.69Z"/></svg></span>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .pp
    {
        position: fixed;
        right: 0px;
        top: 20vh;
        z-index: 10000;
    }
    .pp .bg
    {
        width: 50px;
        height: 220px;
        background-color: #1894e2;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        position: relative;
        box-shadow: 0 4px 8px rgba(0,0,0,0.2);
        transition: all ease 0.3s;
    }
    .pp.expanded .bg
    {
        width: 320px;
        height: 370px;
    } 
    .pp .bg .verTitle
    {
        height: 230px;
        position: absolute;
        right: 0%;                
        top: 50%;
        transform: translateY(-50%); 
        color: #fff;
        font-weight: bold;
        padding: 30px 14px;
        cursor: pointer;
        writing-mode: vertical-rl; 
        text-orientation: mixed;   
        transform: translateY(-50%) rotate(180deg); 
        font-size: 16px;        
    }
    .pp .bg .verTitle span
    {
        color: #fff;
        font-size: 14px;       
        position: relative;
        top: 8px;
        font-weight: 400 !important;
    }
    .pp.pp.expanded .bg .verTitle
    {
        display: none
    }
    .pp .bg .verTitle span svg
    {
        transform: rotate(90deg);
    }
    .pp .contents
    {
        pointer-events: none;
        color: #fff;
        padding: 50px 30px;
        width: 300px;
        height: auto;        
        position: absolute;
        right: 0px;
        top: 0px;
        z-index: 1000;
        font-size: 14px;
        opacity: 0;
        transition: all ease 0.15s;
        transition-delay: 0.1s;
    }
    .pp.expanded .contents
    {
        opacity: 1;
        pointer-events: all;
        transition-delay: 0s;
    }    
    .pp .contents span
    {
        font-size: 22px;
        line-height: 24px;
        font-weight: 500 !important;
        display: block;
        padding-bottom: 20px;
    }
    .pp .contents a
    {
        cursor: pointer;margin-top: 30px;
        font-size: 13px;
        font-weight: 500 !important;
        padding: 10px 20px;
        border: solid 2px #fff;
        border-radius: 50px;
        color: #fff;
        display: inline-block;
    }
    .pp .contents a:hover
    {
        border: solid 2px #fff;background: #fff;color: #1894e2;
    }
    .pp .xx
    {
        position: absolute;
        top: 15px;right: 0px;width: 40px;height: 40px;background-color: #07293b;
        border-radius: 10px 0px 0px 10px;        
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .pp .xx svg{margin: auto;}

    @media only screen and (max-width: 815px) 
    {
        .pp
        {
            position: fixed;
            top: initial;
            bottom: 20vh !important;
        }
    }    


</style>

<script>
export default {
  data() {
    return {
        expanded:false,
        countryCode:'',
    }    
  },
    props: ['country'],
    created()
    {
        
    },
  mounted() 
  {
    //this.countryCode = this.$route.params.country.toLowerCase() || '';
  },
  destroyed() {
  },
  computed: {
  },
  methods: {
    toggle()
    {

    }

}
};
</script>

